import { Provider, forwardRef, KeyValueDiffer, KeyValueDiffers, KeyValueChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, UntypedFormControl } from '@angular/forms';
import { ValidationResult } from '../validators/validation-result.model';

export abstract class ObjectValueAccessor<T> implements ControlValueAccessor {
  public allowNull: boolean = false;
  public validationError: string = '';
  private _value: T;
  private _pristineValue: string;

  public constructor(object: T, allowNullObject: boolean) {
    //allow ability to intialize obejct on inherited "super(object, false) call;
    this._value = object;
    this._pristineValue = JSON.stringify(this._value);
    this.allowNull = allowNullObject;
    this.validationError = '';
  }

  public isValid = (): boolean => {
    //this function will get overriden in the inherited controls
    //to produce their own logic of valid or not
    return true;
  };

  get pristineValue() {
    return this._pristineValue;
  }

  get value(): T {
    return this._value;
  }

  set value(v: T) {
    if (v !== this._value) {
      if (this.allowNull === false) {
        if (v != null && v !== undefined) {
          this._value = v;
          this.onChange(v);
        }
      } else {
        this._value = v;
        this.onChange(v);
      }
    }
  }

  isDirty(): boolean {
    return JSON.stringify(this._value) !== this._pristineValue;
  }

  setPristine() {
    this._pristineValue = JSON.stringify(this._value);
  }

  writeValue(value: T) {
    if (this.allowNull === false) {
      if (value != null && value != undefined) {
        this._value = value;
        this.onChange(value);
      }
    } else {
      this._value = value;
      this.onChange(value);
    }
  }

  onBlur() {
    this.onTouched();
  }

  validate = (c: UntypedFormControl): any => {
    if (this.isValid() == false) {
      //return any custom error object if not valid
      let validationResult: ValidationResult = new ValidationResult();
      validationResult.errors.push(this.validationError);
      return validationResult;
    } else {
      //return null if is valid
      return null;
    }
  };

  onChange = (_: any) => {};
  onTouched = () => {};
  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}

export function CreateObjectValueAccessorProvider(type: any): any {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => type),
    multi: true,
  };
}

export function CreateObjectValueValidationProvider(type: any): any {
  return {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => type),
    multi: true,
  };
}
